const lottoStartDate = `${process.env.VUE_APP_LOTTO_STARTDATE}T00:00:00`;
const nowDate00 = () => {
  const nD = new Date();
  const ny = nD.getFullYear();
  const nm = String(nD.getMonth() + 1).padStart(2, 0);
  const nd = String(nD.getDate()).padStart(2, 0);
  return `${ny}-${nm}-${nd}T00:00:00`;
};

const getDifferenceInDays = (date1, date2) => {
  const diffDate = date1.getTime() - date2.getTime();
  return Math.floor(Math.abs(diffDate / (1000 * 60 * 60 * 24)));
};

const getMonthTurn = (lotto, date) => (date < lotto ? 1 : +getDifferenceInDays(lotto, date) + 1);

const getStartEndTurn = (year, month) => {
  const lottoStDate = new Date(lottoStartDate);

  const startDate = new Date(year, month - 1, 1);
  const lastDate = new Date(year, month, 0);

  // console.log(`${month}월의 말일: ${lastDate.getDate()}일`);

  const currentMonth = `${year}.${String(month).padStart(2, 0)}`;
  const firstTurn = String(getMonthTurn(lottoStDate, startDate)).padStart(2, 0);
  const lastTurn = String(getMonthTurn(lottoStDate, lastDate)).padStart(2, 0);

  // console.log(`${currentMonth}의 첫 회차: ${firstTurn}`);
  // console.log(`${currentMonth}의 마지막 회차: ${lastTurn}`);

  return {
    txt: `${currentMonth} (${firstTurn}~${lastTurn}회)`,
    startRound: +firstTurn,
    endRound: +lastTurn,
  };
};

const getMonthsArr = () => {
  let monthArr = [];

  const lotto = new Date(lottoStartDate);
  const lYear = +lotto.getFullYear();
  const lMonth = +lotto.getMonth() + 1;

  const now = new Date(nowDate00());
  let nYear = +now.getFullYear();
  let nMonth = +now.getMonth() + 1;

  while (!(lYear === nYear && lMonth === nMonth + 1)) {
    monthArr.push({ year: nYear, month: nMonth });

    nMonth--;
    if (nMonth === 0) {
      nMonth = 12;
      nYear = nYear - 1;
    }
  }
  // console.log(`monthArr: ${JSON.stringify(monthArr)}`);

  // const resultMonthArr = monthArr.map((el) => getStartEndTurn(el.year, el.month));

  // console.log(resultMonthArr);
  return monthArr;
};

const turns = () => getMonthsArr().map((el) => getStartEndTurn(el.year, el.month));

export default {
  install(Vue) {
    Vue.prototype.$testLottoDate = turns;
  },
};